import { createSlice, } from "@reduxjs/toolkit";


// export const SCHEDULE_CALL = "schedule_call";
// export const CTR = "ctr_booster"
// export const MAP_CHECKINS ="map_checkins"

// type BookingType = "schedule_call" | "ctr_booster" | "map_checkins"
interface ScheduleCallType {
    header: string;
    subHeader1?: string;
    subHeader2?: string;
    src: string;
    id: string
}

const myData = {
    scheduleCall: {
        header: "Let us take over - Book a call to get started",
        src: "https://link.mapranking.com/widget/booking/MUGJhTsLQibn3xc4OlVR",
        id: "mkEWBTGPPqmcrtdukohR_1756184951209",
        subHeader1: "Book a free discovery call and let's talk about how our team",
        subHeader2: "can take over your entire local SEO strategy",
    },
    ctr: {
        header: "CTR Booster Onboarding Call Calendar",
        src: "https://link.mapranking.com/widget/booking/iXkFJG5DCuTcIMVkRfyJ",
        id: "IsNZ8mPRWCNhGEXtPfZy_1757086368414",
        subHeader1: "",
        subHeader2: "",
    },
    mapCheckins: {
        header: "Map Check-Ins Onboarding Call Calendar",
        src: "https://link.mapranking.com/widget/booking/Q9teAqQ4PxdJziEYaJeq",
        id: "IsNZ8mPRWCNhGEXtPfZy_1757087428445",
        subHeader1: "",
        subHeader2: "",
    }
}



const initialState: ScheduleCallType = {
    header: "Let us take over - Book a call to get started",
    subHeader1: "Book a free discovery call and let's talk about how our team",
    subHeader2: "can take over your entire local SEO strategy",
    src: "https://link.mapranking.com/widget/booking/MUGJhTsLQibn3xc4OlVR",
    id: "mkEWBTGPPqmcrtdukohR_1756184951209"
};

const scheduleCallSlice = createSlice({
    name: "schedule_a_call",
    initialState,
    reducers: {
        setCall(state) {
            state.header = myData.scheduleCall.header;
            state.id = myData.scheduleCall.id;
            state.src = myData.scheduleCall.src;
            state.subHeader1 = myData.scheduleCall.subHeader1;
            state.subHeader2 = myData.scheduleCall.subHeader2;
        },

        setCTROnBoarding(state) {
            state.header = myData?.ctr?.header;
            state.id = myData?.ctr?.id;
            state.src = myData?.ctr?.src;
            state.subHeader1 = myData?.ctr?.subHeader1;
            state.subHeader2 = myData?.ctr?.subHeader2;
        },

        setMapOnboarding(state) {
            state.header = myData?.mapCheckins?.header;
            state.id = myData?.mapCheckins?.id;
            state.src = myData?.mapCheckins?.src;
            state.subHeader1 = myData?.mapCheckins?.subHeader1;
            state.subHeader2 = myData?.mapCheckins?.subHeader2;
        },
    },
});

export const { setCall, setCTROnBoarding, setMapOnboarding } = scheduleCallSlice.actions;
export default scheduleCallSlice.reducer;